import { useCallback, useEffect, useState } from 'react';
import type { LeadProposalGenerationType } from '@econtractor/types';
import * as apiProposal from 'api/apiProposal';

const findAcceptedGeneration = (rows: LeadProposalGenerationType[]) =>
    rows.find((row) => Boolean(row.proposavAccept)) || null;

const useLeadAcceptedProposal = (leadId?: number | string | null) => {
    const [acceptedGeneration, setAcceptedGeneration] = useState<LeadProposalGenerationType | null>(null);
    const [loading, setLoading] = useState(false);

    const refreshAccepted = useCallback(async () => {
        const targetLeadId = Number(leadId || 0);
        if (!targetLeadId) {
            setAcceptedGeneration(null);
            return;
        }
        setLoading(true);
        const result = await apiProposal.getLeadProposalGenerations(targetLeadId);
        setAcceptedGeneration(findAcceptedGeneration(result || []));
        setLoading(false);
    }, [leadId]);

    useEffect(() => {
        void refreshAccepted();
    }, [refreshAccepted]);

    return {
        acceptedGeneration,
        loading,
        refreshAccepted,
    };
};

export default useLeadAcceptedProposal;
